import {
  trigger,
  animate,
  transition,
  style,
} from '@angular/animations';
import { ANIMATION } from './animation.constants';

const duration = ANIMATION.duration;

export const fadeAnimation = trigger('fadeAnimation', [
  transition(':enter', [
    style({ opacity: 0, transform: 'translate3d(0px, 0px, 10px)' }),
    animate(
      duration + ' 0s ease-in-out',
      style({ opacity: 1, transform: 'translate3d(0px, 0px, 10px)' })
    ),
  ]),
  transition(':leave', [
    style({ opacity: 1, transform: 'translate3d(0px, 0px, 0px)' }),
    animate(
      duration + ' ' + duration + ' ease-out',
      style({ opacity: 0, transform: 'translate3d(0px, 0px, 0px)' })
    ),
  ]),
]);


